import { z } from "zod";

/**
 * Session Types and Schemas
 * Zod validation schemas for Better Auth session data
 */

/**
 * Better Auth session schema for MongoDB
 * Uses _id (ObjectId) since we query MongoDB directly
 */
export const SessionSchema = z.object({
  _id: z.union([z.string(), z.instanceof(Object)]).transform((val) => val.toString()),
  userId: z.string(),
  expiresAt: z.date(),
  createdAt: z.date(),
  updatedAt: z.date(),
  token: z.string().optional(),
  ipAddress: z.string().optional(),
  userAgent: z.string().optional(),
});

export type ISession = z.infer<typeof SessionSchema>;

/**
 * Active session with user info
 * Combines session data with user details
 * Both session and user use _id from MongoDB
 */
export const ActiveSessionSchema = z.object({
  session: SessionSchema,
  user: z.object({
    _id: z.union([z.string(), z.instanceof(Object)]).transform((val) => val.toString()),
    username: z.string(),
    email: z.string().email(),
    name: z.string(),
    // any of the Role enum's internal values, not just the three B2B ones
    role: z.string(),
  }),
});

export type IActiveSession = z.infer<typeof ActiveSessionSchema>;
